// Keep in sync with src/assets/styles/_breakpoints.scss (breakpoint.service.spec.ts checks that).
export const BREAKPOINTS = { sm: 600, md: 768, lg: 1024, xl: 1280 } as const;

export type Layout = 'phone' | 'tablet' | 'tablet-landscape' | 'desktop';
